import { connect } from "react-redux";
import { mapStateToProps } from "../store/helpers/mapState";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import moment from "moment";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AddModeratorIcon from "@mui/icons-material/AddModerator";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import { Chip, Collapse, Typography } from "@mui/material";
import { useState } from "react";

function RequestTimeline({ content, userId }) {
  const [readMore, setReadMore] = useState(false);
  const [index, setIndex] = useState(null);

  const getStatusLabel = (status) => {
    switch (status) {
      case "approved":
        return "Approved";
      case "forwarded":
        return "Forwarded";
      case "denied":
        return "Denied";
      case "created":
        return "Created";
      case "missing information":
        return "Missing Information";
      default:
        return "Pending";
    }
  };

  const getStepLabel = (item) => {
    // First check if it's a step-specific status
    if (item.status?.includes("approval")) {
      const stepIndex = item.stepIndex;
      if (stepIndex !== undefined && item.stepName) {
        return `${item.stepName} (${item.status.split("-")[0]} approval)`;
      }
    }

    // Fallback to standard status mapping
    const statusMap = {
      "pending-review": "Pending Review",
      "under-review": "Under Review",
      approved: "Final Approval",
      denied: "Request Denied",
      "first-approval": "First Approval",
      "second-approval": "Second Approval",
      "third-approval": "Third Approval",
      // ...other statuses
    };

    return statusMap[item.status] || item.stepName || item.status;
  };

  return (
    <Timeline position="right" className={"float-start"}>
      {content
        // Already filtered in the parent component, just process the received content
        ?.map((v, i) => {
          let approved = v.status === "approved";
          let forwarded = v.status === "forwarded";
          let denied = v.status === "denied";
          let created = v.status === "created";
          let missing = v.status === "missing information";
          let me = v.resourceId === userId;
          return (
            <TimelineItem>
              <TimelineOppositeContent
                sx={{ m: "auto 0" }}
                align="right"
                variant="body2"
                color="text.secondary"
              >
                {moment(v.createdAt).format("yyyy-MM-DD hh:mm:ss")}
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineConnector />
                <TimelineDot
                  color={
                    missing
                      ? "secondary"
                      : created
                      ? "grey"
                      : approved
                      ? "success"
                      : forwarded
                      ? "info"
                      : denied
                      ? "error"
                      : "warning"
                  }
                >
                  {forwarded ? (
                    <ForwardToInboxIcon />
                  ) : missing ? (
                    <HelpOutlineIcon />
                  ) : created ? (
                    <AddModeratorIcon />
                  ) : denied ? (
                    <DoDisturbIcon />
                  ) : approved ? (
                    <AssignmentTurnedInIcon />
                  ) : (
                    <PendingActionsIcon />
                  )}
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: "12px", px: 2 }}>
                <Typography variant="h6" component="span">
                  {getStepLabel(v)}
                </Typography>
                <Typography>{v.Resource?.names}</Typography>
                {/* {v.comment && (
                  <Typography variant="body2" color="textSecondary">
                    {v.comment}
                  </Typography>
                )} */}
                <Typography>
                  <em
                    className="text-info"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (readMore && index !== i) {
                        setReadMore(true);
                      } else setReadMore(!readMore);

                      setIndex(i);
                    }}
                  >
                    Read comment
                  </em>
                  <Collapse in={readMore && index === i}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: v.comment ?? "",
                      }}
                    />
                  </Collapse>
                </Typography>
                <Chip
                  style={missing ? { backgroundColor: "#9c27b0" } : undefined}
                  color={
                    created
                      ? "default"
                      : approved
                      ? "success"
                      : forwarded
                      ? "info"
                      : v.status === "denied"
                      ? "error"
                      : "warning"
                  }
                  label={v.status ?? "Pending"}
                />
              </TimelineContent>
            </TimelineItem>
          );
        })}
    </Timeline>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestTimeline);
